import ChipTicketStatus from '@/components/chip/ChipTicketStatus';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: t('Mã Ticket'),
        editable: false,
        sortable: true,
        minWidth: 150,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: t('Tên', 'TicketList'),
        editable: false,
        sortable: false,
        minWidth: 250,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'customer.name',
        headerName: t('Khách hàng'),
        editable: false,
        sortable: false,
        minWidth: 250,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.customer?.name}>
                <EntityDetailButton
                    text={params.row.customer?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.customerId}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: 'ticketType.name',
        headerName: t('Loại Ticket'),
        editable: false,
        sortable: false,
        minWidth: 120,
        renderCell: params => (
            <HoverCopyCell value={params.row.ticketType?.name} />
        ),
    },
    {
        field: 'scheduledTime',
        headerName: t('Ngày bắt đầu'),
        editable: false,
        sortable: true,
        minWidth: 120,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: 'ticketStatus',
        headerName: t('Trạng thái', 'TicketList'),
        editable: false,
        sortable: false,
        minWidth: 120,
        renderCell: params => (
            <ChipTicketStatus status={params.row.ticketStatus} size='small' />
        ),
    },
    {
        field: 'createdDate',
        headerName: t('Ngày tạo'),
        editable: false,
        sortable: true,
        minWidth: 120,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
